import React, { useEffect, useState } from 'react';
import Home_page_product3_single_item from './Home_page_product3_single_item';
import "./Home_page_product4.css";
import { useNavigate } from 'react-router-dom';

function Home_page_product4({ category }) {

  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  const airConditioners = [
    "FTKL50UV16VAF INDOOR",
    "RAS.V518PCCISH1 (5500STXL-4W) INV INDOOR",
    "1.5 TON 3 STAR INV GLS18I3LWSBA INDOOR",
    "CS-EU18AKY3F INDOOR",
    "HS-18KPYSG3BN(INV) INDOOR",
    "USNQ18LNXE.AMLG INDOOR",
  ];

  const refrigerator = [
    "RR21C2H25RZ/HL",
    "215 IMPRO ROY 5S INV WINE FOREST-Z",
    "RT EONALPHA 270B RI ST GL",
    "NEO DF278 PRM 2S TITAN STEEL-TL",
    "RS EON VELVET 579 RFD GL BK",
    "RS76CG80X0S9HL",
  ]

  const mobileAndTab = [
    "VIVO MOBILE X200 NATURAL GREEN (12GB+256GB)",
    "IPHONE 16 BLACK 128GB",
    "SM-S921BZKC S24 ONYX BLACK (8GB+256GB)",
    "NOTHING PHONE 2A BLUE (8GB+128GB)",
    "MOTOROLA MOBILE MOTO EDGE 50 GREY (8GB+256GB)",
    "REDMI NOTE 13 PRO 5G CORAL PURPLE (8GB+128GB)",
  ]

  const tvAndHomeEntertainment = [
    "UA32T4350BKXXL",
    "32LQ640BPTA.ATRQ",
    "KD-32W830K IN5",
    "UA43AU7600KXXL",
    "LLOYD PANEL 32HS550F (GL32H4A2LN)",
    "TH-32MS680DX",
  ]

  const computerAndLaptop = [
    "HP LAPTOP 15S-FQ5326TU",
    "DELL LAPTOP OIN352010022RINS1M",
    "LENOVO LAPTOP 82KBA002IH",
    "ACER LAPTOP UN.31ZSI.004",
    "HP LAPTOP 15-FA1312TX",
    "DELL LAPTOP OIN352010021RINS1M",
  ]

  const audio = [
    "NOISE HEADPHONE AUD-HDPHN-BUDSVS106-BLK",
    "NOISE HEADPHONE AUD-HDPHN-TWO-BLK",
    "OPPO ENCO AIR2I MOONLIGHT",
    "REALME BUDS WIRELESS 2 NEO BLACK RMA2011",
    "APPLE AIRPODS PRO 2ND GEN WITH MAGSAFE-MTJV3HN/A",
    "FIRE BOLTT TRUE WIRELESS EARBUDS BEG211 BLACK",
  ]

  const washingMachine = [
    "SERENA ZSS 7010",
    "WW80TA046AB1TL",
    "ACE 7.5 SUPER SOAK (GREY DAZZLE) (10YR)",
    "P7010NBAZ.ADBQNST",
    "WT EON ADR 70 5.0 PFDTN GP GR",
    "NA-F80V10SRB",
  ]

  const microwaveOven = [
    "23BC4",
    "MC2846BG.DBKQILN",
    "NN-CT36HBFDG",
    "HIL2001CSSH",
    "24PM2B",
    "MS2043DB.DB1QILN",
  ]

  const kitchenChimney = [
    "KUTCHINA CHIMNEY VEGA DLX 60",
    "KUTCHINA CHIMNEY VENTO 60",
    "SUNFLAME INNOVA 90 AUTO CLEAN DX-(BK)",
    "FABER HOOD SUNNY IN HC SC FL LG 60",
    "COOKER HOOD EC1-BS-HS-60 BF",
    "COOKER HOOD EC1-BS-HS-90 BF",
  ]

  const mixerGrinder = [
    "BAJAJ NINJA SERIES GRACIO 500W LILAC",
    "POWER HUNK 3 JAR 800W",
    "USHA MIXER GRINDER 500W SPEEDMASTER RED",
    "MG 800W MAXIMUSPL MP800MX4 BLACK SS FINI",
    "MOMENTA NV 3 JAR MIXER GRINDER-750 WATT",
    "BAJAJ NINJA SERIES CARVE 750W PURPLE",
  ]


  // async function fetchProducts() {
  //   try {
  //     const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/excel-data', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         queryStringParameters: {
  //           field: "Categories",
  //           value: category
  //         }
  //       }),
  //     });
  //     const data = await response.json();
  //     const cleanedBody = data.body.replace(/NaN/g, 'null');
  //     const parsedData = JSON.parse(cleanedBody);
  //     return parsedData;

  //   } catch (error) {
  //     console.log("Error fetching data:", error);
  //   }
  // }

  // useEffect(() => {
  //   async function fetchData() {
  //     const products = await fetchProducts();
  //     //console.log(products);
  //     setProducts(products?.slice(0, 6));
  //   }

  //   fetchData();
  // }, [category]);
  
  async function fetchProductDetails(productId) {
    try {
      const response = await fetch(
        "https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/excel-data",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            queryStringParameters: {
              field: "Model",
              value: productId,
            },
          }),
        }
      );
      
      const data = await response.json();
      console.log("Data of product details page:", data);
      const cleanedBody = data.body.replace(/NaN/g, "null");
      const parsedData = JSON.parse(cleanedBody);
      console.log("Parsed data of product details page:", parsedData);
      return parsedData[0];
    } catch (error) {
      console.error("Error fetching product details:", error);
      return null;
    }
  }
  
  // Function to determine which array to use based on category
  function getProductArrayByCategory(category) {
    switch(category) {
      case "AIR CONDITIONER":
        return airConditioners;
      case "REFRIGERATOR":
        return refrigerator;
      case "Mobile & Tab":
        return mobileAndTab;
      case "TV & HOME ENTERTAINMENT":
        return tvAndHomeEntertainment;
      case "COMPUTER & LAPTOP":
        return computerAndLaptop;
      case "AUDIO":
        return audio;
      case "WASHING MACHINE":
        return washingMachine;
      case "MICROWAVE OVENS":
        return microwaveOven;
      case "KITCHEN APPLIANCES":
        return kitchenChimney;
      case "MIXER GRINDER":
        return mixerGrinder;
      default:
        return [];
    }
  }
  
  // Updated useEffect to use the new functions
  useEffect(() => {
    async function fetchData() {
      // Get the appropriate product array based on category
      const productArray = getProductArrayByCategory(category);
      
      // Create array of promises for all product details
      const productPromises = productArray.map(productId => fetchProductDetails(productId));
      
      try {
        // Fetch all products in parallel
        const productDetails = await Promise.all(productPromises);
        
        // Filter out any null results (failed requests)
        const validProducts = productDetails.filter(product => product !== null);
        
        console.log("All product details fetched:", validProducts);
        setProducts(validProducts);
      } catch (error) {
        console.error("Error fetching product details:", error);
      }
    }
  
    fetchData();
  }, [category]);
  
  return (
    <div className="Home_page_product4_container">
      <h4 className="Home_page_product4_heading">{category}</h4>
      <div className="Home_page_product4_product_grid">
        {products?.map((product) => (
          <Home_page_product3_single_item product={product} />
        ))}
      </div>
      <div className="Home_page_product4_viewall_container">
        <button className='Home_page_product4_viewall' onClick={() => navigate(`/category/${category}`)}>View All</button>
      </div>

    </div>
  );
}


export default Home_page_product4;